<h1 mat-dialog-title i18n>Submit</h1>
<form [formGroup]="data.group.control" (ngSubmit)="onSubmit()">
  <div mat-dialog-content>
    <div class="form-container">
      <eas-easform-group [easGroup]="data.group" [templates]="{}">
        </eas-easform-group>
    </div>
  </div>
  <div mat-dialog-actions>
    <ub-button-list>
      <button mat-flat-button color="primary" type="submit" [disabled]="submitted" i18n>Save</button>
      <button mat-flat-button color="warn" [mat-dialog-close]="canceled" i18n>Cancel</button>
    </ub-button-list>
  </div>
</form>
